import Vue from 'vue'
import Router from 'vue-router'
import SignIn from './views/SignIn.vue'
Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}

export default new Router({
	base: process.env.BASE_URL,
	routes: [{
		path: '/',
		name: 'SignIn',
		component: SignIn
	},
	{
		path: '/headpage',
		name: 'headpage',
		component: () => import('./views/Index.vue')
	},
	{
		path: '/home',
		name: 'home',
		component: () => import('./views/home.vue'),
		children: [{
			path: "/index",
			name: 'index',
			component: () => import('./views/Index.vue'),
		},
		{
			// 看板
			path: "/homeMain",
			name: 'homeMain',
			component: () => import('./views/price/homeMain.vue'),
		},
		{
			// 待报价
			path: "/manageMain",
			name: 'manageMain',
			component: () => import('./views/price/manageMain.vue'),
		},

		{
			// 部位分组管理
			path: "/positionGroup",
			name: 'positionGroup',
			component: () => import('./views/testDataManage/positionGroup.vue'),
		},
		{
			// 报表部位分组
			path: "/reportPositionGroup",
			name: 'reportPositionGroup',
			component: () => import('./views/testDataManage/reportPositionGroup.vue'),
		},
		{
			// 结果模板
			path: "/resultTemplate",
			name: 'resultTemplate',
			component: () => import('./views/testDataManage/resultTemplate.vue'),
		},
		{
			// 车辆检测数据
			path: "/dossierManager",
			name: 'dossierManager',
			component: () => import('./views/testDataManage/dossierManager.vue'),
		},
		{
			// 车辆档案删除信息
			path: "/delCarDossier",
			name: 'delCarDossier',
			component: () => import('./views/testDataManage/delCarDossier.vue'),
		},
		{
			// 进站台次
			path: "/inCarManage",
			name: 'inCarManage',
			component: () => import('./views/testDataManage/inCarManage.vue'),
		},
		{
			// 站点日其他成交
			path: "/orgDayOtherDeal",
			name: 'orgDayOtherDeal',
			component: () => import('./views/testDataManage/orgDayOtherDeal.vue'),
		},
		{
			// LVHC重点易损件 目标录入
			path: "/pointOptionList",
			name: 'pointOptionList',
			component: () => import('./views/testDataManage/pointOptionList.vue'),
		},
		{
			// 留言板字典管理
			path: "/messageManage",
			name: 'messageManage',
			component: () => import('./views/testDataManage/messageManage.vue'),
		},
		{
			// 留言板字典管理
			path: "/messageManageDetail",
			name: 'messageManageDetail',
			component: () => import('./views/testDataManage/messageManageDetail.vue'),
		},

			{
				// 技师分组
				path: "/workerGroup",
				name: 'workerGroup',
				component: () => import('./views/testDataManage/workerGroup.vue'),
			},

			{
				// 成交批量登记
				path: "/dealDataRegistration",
				name: 'dealDataRegistration',
				component: () => import('./views/testDataManage/dealDataRegistration.vue'),
			},

			{
				// 失销原因管理
				path: "/reasonManage",
				name: 'reasonManage',
				component: () => import('./views/testDataManage/reasonManage.vue'),
			},

		{
			// 管理人员
			path: "/leaderManage",
			name: 'leaderManage',
			component: () => import('./views/accountManage/leaderManage.vue'),
		},
		{
			// 检测技师
			path: "/workerManage",
			name: 'workerManage',
			component: () => import('./views/accountManage/workerManage.vue'),
		},
		{
			// 服务顾问
			path: "/saManage",
			name: 'saManage',
			component: () => import('./views/accountManage/saManage.vue'),
		},
		{
			// 配件员
			path: "/partsUserManage",
			name: 'partsUserManage',
			component: () => import('./views/accountManage/partsUserManage.vue'),
		},
		{
			// 绑定管理
			path: "/trussManage",
			name: 'trussManage',
			component: () => import('./views/accountManage/trussManage.vue'),
		},
		{
			// 绑定管理
			path: "/deviceAuthList",
			name: 'deviceAuthList',
			component: () => import('./views/accountManage/deviceAuthList.vue'),
		},

		{
			// 配件
			path: "/partsList",
			name: 'partsList',
			component: () => import('./views/dataManage/partsList.vue'),
		},
		{
			// 工时
			path: "/workHoursList",
			name: 'workHoursList',
			component: () => import('./views/dataManage/workHoursList.vue'),
		},

		// {
		// 	// 全车运营统计   (废弃)
		// 	path: "/businessIntelligence",
		// 	name: 'businessIntelligence',
		// 	component: () => import('./views/vehicleInspectionAnalysis/businessIntelligence.vue'),
		// },
		// {
		// 	// 全车运营统计   (废弃)
		// 	path: "/dailyTestAndDeal",
		// 	name: 'dailyTestAndDeal',
		// 	component: () => import('./views/vehicleInspectionAnalysis/dailyTestAndDeal.vue'),
		// },
		// {
		// 	// 全车运营统计   (废弃)
		// 	path: "/dailyTestAndDealChart",
		// 	name: 'dailyTestAndDealChart',
		// 	component: () => import('./views/vehicleInspectionAnalysis/dailyTestAndDealChart.vue'),
		// },
		{
			// 报告跟踪分析
			path: "/dossierRequestLogSys",
			name: 'dossierRequestLogSys',
			component: () => import('./views/vehicleInspectionAnalysis/dossierRequestLogSys.vue'),
		},
		{
			// 趋势报表
			path: "/trendLineChart",
			name: 'trendLineChart',
			component: () => import('./views/charts/trendLineChart.vue'),
		},
		{
			// 常用
			path: "/inCommonUse",
			name: 'inCommonUse',
			component: () => import('./views/vehicleInspectionAnalysis/commonlyUsed.vue'),
		},
		{
			// 运营数据统计
			path: "/OperationDataStatistics",
			name: 'OperationDataStatistics',
			component: () => import('./views/vehicleInspectionAnalysis/OperationDataStatistics.vue'),
		},
		{
			// 运营BI报表
			path: "/BIreport",
			name: 'BIreport',
			component: () => import('./views/vehicleInspectionAnalysis/BIreport.vue'),
		},

		{
			// LVHC重点易损件报表
			path: "/pointOptionReport",
			name: 'pointOptionReport',
			component: () => import('./views/OperationDataStatistics/pointOptionReport.vue'),
		},
		{
			// 检测汇总月度统计
			path: "/detectionSummary",
			name: 'detectionSummary',
			component: () => import('./views/OperationDataStatistics/detectionSummary.vue'),
		},
		{
			// 检出成交项目统计
			path: "/checkDeal",
			name: 'checkDeal',
			component: () => import('./views/OperationDataStatistics/checkDeal.vue'),
		},
		{
			// 服务顾问绩效统计
			path: "/SAAchievementsSummany",
			name: 'SAAchievementsSummany',
			component: () => import('./views/OperationDataStatistics/SAAchievementsSummany.vue'),
		},
		{
			// 服务顾问成交项目
			path: "/SADealSummany",
			name: 'SADealSummany',
			component: () => import('./views/OperationDataStatistics/SADealSummany.vue'),
		},
		{
			// 检出车型成交统计
			path: "/modelDealSummany",
			name: 'modelDealSummany',
			component: () => import('./views/OperationDataStatistics/modelDealSummany.vue'),
		},
		{
			// SA成交项目个数
			path: "/SAdealNumber",
			name: 'SAdealNumber',
			component: () => import('./views/OperationDataStatistics/SAdealNumber.vue'),
		},
		{
			// 换件登记检测日报
			path: "/registrationDayReport",
			name: 'registrationDayReport',
			component: () => import('./views/OperationDataStatistics/registrationDayReport.vue'),
		},
		{
			// SA成交轮胎个数排名
			path: "/tireDealList",
			name: 'tireDealList',
			component: () => import('./views/OperationDataStatistics/tireDealList.vue'),
		},





		{
			// 销售成交统计
			path: "/salesDealSummany",
			name: 'salesDealSummany',
			component: () => import('./views/DataManagementReport/salesDealSummany.vue'),
		},
		{
			// 检测档案查询
			path: "/testDossierSearch",
			name: 'testDossierSearch',
			component: () => import('./views/DataManagementReport/testDossierSearch.vue'),
		},
		{
			// 检测清单导出
			path: "/testListDownload",
			name: 'testListDownload',
			component: () => import('./views/DataManagementReport/testListDownload.vue'),
		},
		{
			// 失销统计分析
			path: "/lossSale",
			name: 'lossSale',
			component: () => import('./views/DataManagementReport/lossSale.vue'),
		},
		{
			// 报告跟踪分析
			path: "/openReport",
			name: 'openReport',
			component: () => import('./views/DataManagementReport/openReport.vue'),
		},
		{
			// 管理人员活跃度
			path: "/manageAction",
			name: 'manageAction',
			component: () => import('./views/DataManagementReport/manageAction.vue'),
		},
		{
			// 已隐藏检测数据
			path: "/hiddenPartList",
			name: 'hiddenPartList',
			component: () => import('./views/DataManagementReport/hiddenPartList.vue'),
		},






		{
			// 日报
			path: "/PowerBI0",
			name: 'PowerBI0',
			component: () => import('./views/charts/PowerBI0.vue'),
		},
		{
			// 周报
			path: "/PowerBI1",
			name: 'PowerBI1',
			component: () => import('./views/charts/PowerBI1.vue'),
		},
		{
			// 月报
			path: "/PowerBI2",
			name: 'PowerBI2',
			component: () => import('./views/charts/PowerBI2.vue'),
		},
		{
			// 车型分析
			path: "/PowerBI3",
			name: 'PowerBI3',
			component: () => import('./views/charts/PowerBI3.vue'),
		},
		{
			// 里程分析
			path: "/PowerBI4",
			name: 'PowerBI4',
			component: () => import('./views/charts/PowerBI4.vue'),
		},
		{
			// 检测转化率分析
			path: "/PowerBI5",
			name: 'PowerBI5',
			component: () => import('./views/charts/PowerBI5.vue'),
		},
		{
			// 检测部位成交分析
			path: "/PowerBI6",
			name: 'PowerBI6',
			component: () => import('./views/charts/PowerBI6.vue'),
		},
		{
			// 失销统计分析
			path: "/PowerBI7",
			name: 'PowerBI7',
			component: () => import('./views/charts/PowerBI7.vue'),
		},
		{
			// 报告访问分析
			path: "/PowerBI8",
			name: 'PowerBI8',
			component: () => import('./views/charts/PowerBI8.vue'),
		},
		{
			// 日报
			path: "/PowerBI9",
			name: 'PowerBI9',
			component: () => import('./views/charts/PowerBI10.vue'),
		},



		{
			// 服务顾问成交率
			path: "/compareBI1",
			name: 'compareBI1',
			component: () => import('./views/charts/compareBI1.vue'),
		},
		{
			// 检测技师KPI对比
			path: "/compareBI2",
			name: 'compareBI2',
			component: () => import('./views/charts/compareBI2.vue'),
		},
		{
			// 检测技师KPI对比
			path: "/compareBI21",
			name: 'compareBI21',
			component: () => import('./views/charts/compareBI21.vue'),
		},
		{
			// 项目检出异常项目对比
			path: "/compareBI3",
			name: 'compareBI3',
			component: () => import('./views/charts/compareBI3.vue'),
		},


			{
				// 车辆跟踪管理
				path: "/carFollowingEfficiency",
				name: 'carFollowingEfficiency',
				component: () => import('./views/constructionManage/carFollowingEfficiency.vue'),
			},
			{
				// 技师检测效率
				path: "/workerEfficiency",
				name: 'workerEfficiency',
				component: () => import('./views/constructionManage/workerEfficiency.vue'),
			},
			{
				// 工位使用情况
				path: "/stationEfficiency",
				name: 'stationEfficiency',
				component: () => import('./views/constructionManage/stationEfficiency.vue'),
			},


			{ //角色列表
				path: "/roleManage",
				name: 'roleManage',
				component: () => import('./views/sysUser/roleManage.vue'),
			},


			{
				// 车间效率管理
				path: "/efficiencyManage",
				name: 'efficiencyManage',
				component: () => import('./views/DataManagementReport/efficiencyManage.vue'),
			},
			{
				// 前台效率管理
				path: "/receptionManage",
				name: 'receptionManage',
				component: () => import('./views/DataManagementReport/receptionManage.vue'),
			},


			{
				// 环检图片库
				path: "/queryMediaLibraryCountInfo",
				name: 'queryMediaLibraryCountInfo',
				component: () => import('./views/pictureLibrary/queryMediaLibraryCountInfo.vue'),
			},

			{
				// 营销配置
				path: "/marketingList",
				name: 'marketingList',
				component: () => import('./views/marketingManage/marketingList.vue'),
			},


			{
				// 全车照片质量核查
				path: "/dossierImageVerify",
				name: 'dossierImageVerify',
				component: () => import('./views/vehicleInspectionAnalysis/dossierImageVerify.vue'),
			},

		// 自定义设置

			{// 表单分组
				path: "/formGroup",
				name: 'formGroup',
				component: () => import('./views/customSetting/formGroup.vue'),
			},
			{// 录入元素
				path: "/inputElement",
				name: 'inputElement',
				component: () => import('./views/customSetting/inputElement.vue'),
			},
			{// 字典列表
				path: "/dictionaryList",
				name: 'dictionaryList',
				component: () => import('./views/customSetting/dictionaryList.vue'),
			},
			{// 字典列表详情
				path: "/dictionaryListDetail",
				name: 'dictionaryListDetail',
				component: () => import('./views/customSetting/dictionaryListDetail.vue'),
			},



			{// 计划管理
				path: "/planManage",
				name: 'planManage',
				component: () => import('./views/keynoteOptionManage/planManage'),
			},
			{// 计划目标详情
				path: "/planDetail",
				name: 'planDetail',
				component: () => import('./views/keynoteOptionManage/planDetail'),
			},
			{// 登记管理
				path: "/registrationManage",
				name: 'registrationManage',
				component: () => import('./views/keynoteOptionManage/registrationManageWorker'),
			},
			{// 转化率报告
				path: "/registrationReport",
				name: 'registrationReport',
				component: () => import('./views/keynoteOptionManage/registrationReport'),
			},

			{// 计划管理 --- 技师
				path: "/planManageWorker",
				name: 'planManageWorker',
				component: () => import('./views/keynoteOptionManage/planManageWorker'),
			},
			{// 计划目标详情 --- 技师
				path: "/planDetailWorker",
				name: 'planDetailWorker',
				component: () => import('./views/keynoteOptionManage/planDetailWorker'),
			},
			{// 转化率报告 --- 技师
				path: "/registrationReportWorker",
				name: 'registrationReportWorker',
				component: () => import('./views/keynoteOptionManage/registrationReportWorker'),
			},

			{// 技师-跟车效率-日报
				path: "/followEfficiencyDay",
				name: 'followEfficiencyDay',
				component: () => import('./views/OperationDataStatistics/followEfficiencyDay'),
			},
			{// 技师-跟车效率-月报
				path: "/followEfficiencyMonth",
				name: 'followEfficiencyMonth',
				component: () => import('./views/OperationDataStatistics/followEfficiencyMonth'),
			},
			{// 技师-检测效率-日报
				path: "/checkEfficiencyDay",
				name: 'checkEfficiencyDay',
				component: () => import('./views/OperationDataStatistics/checkEfficiencyDay'),
			},
			{// 技师-检测效率-月报
				path: "/checkEfficiencyMonth",
				name: 'checkEfficiencyMonth',
				component: () => import('./views/OperationDataStatistics/checkEfficiencyMonth'),
			},


			{// 项目分组列表
				path: "/projectGroupManage",
				name: 'projectGroupManage',
				component: () => import('./views/projectGroupIncome/projectGroupManage'),
			},
			{// 销售项目收入
				path: "/saleRegistrationManage",
				name: 'saleRegistrationManage',
				component: () => import('./views/projectGroupIncome/saleRegistrationManage'),
			},
			{// 销售项目收入报表
				path: "/powerBISalesIncome",
				name: 'powerBISalesIncome',
				component: () => import('./views/projectGroupIncome/powerBISalesIncome'),
			},


			{// 品牌营销话术
				path: "/brandMarkingManage",
				name: 'brandMarkingManage',
				component: () => import('./views/transmissionOilManage/brandMarkingManage'),
			},
			{// 站点营销话术
				path: "/orgMarkingManage",
				name: 'orgMarkingManage',
				component: () => import('./views/transmissionOilManage/orgMarkingManage'),
			},

			//  自定义动态报表设置

			// {// 报表设置
			// 	path: "/reportFormSetting",
			// 	name: 'reportFormSetting',
			// 	component: () => import('./views/customSetting/reportFormSetting.vue'),
			// },
			// {// 数字区间 详情
			// 	path: "/valueTextDetail",
			// 	name: 'valueTextDetail',
			// 	component: () => import('./views/customSetting/valueTextDetail.vue'),
			// },
			// {// 自定义报表
			// 	path: "/test",
			// 	name: 'test',
			// 	component: () => import('./views/test/test.vue'),
			// },




		]
	},




	]
})
